


























































































import Vue from 'vue';
import { Practice } from '@/models/practice.model';
import { Message } from '@/models/message.model';
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/storage';
import { db, storage } from '@/main';
import { Position } from '@/models/position.model';
import { v4 as uuidv4 } from 'uuid';

export default Vue.extend({
  name: 'Messages',
  data() {
    return {
      practice: {} as Practice,
      position: {} as Position,
      messagesListener: (null as null | {}) as () => void,
      messages: [] as Message[],
      messageText: '',
      uploadProgress: 0,
      file: {} as undefined | File,
      fileUrls: [] as { name: string; url: string }[]
    };
  },
  methods: {
    getData() {
      if (this.messagesListener) {
        this.messagesListener();
      }
      this.messagesListener = db
        .collection('requests')
        .doc(this.$route.query.requestUid as string)
        .collection('messages')
        .orderBy('time')
        .onSnapshot(
          (snapshot: firebase.firestore.QuerySnapshot) => {
            if (snapshot.docs.length > 0) {
              this.messages = snapshot.docs.map(
                value => value.data() as Message
              );
            }
          },
          (error: Error) => {
            console.error(error);
          }
        );
    },
    setData() {
      const message = {
        uid: db.collection('requests').doc().id,
        time: firebase.firestore.Timestamp.now(),
        fromUid: this.$store.state.currentUser.uid,
        fromName: this.$store.state.currentUser.name,
        fromSurname: this.$store.state.currentUser.surname,
        requestUid: this.$route.query.requestUid as string,
        text: this.messageText,
        fileUrls: this.fileUrls
      } as Message;
      db.collection('requests')
        .doc(this.$route.query.requestUid as string)
        .collection('messages')
        .add(message)
        .then(() => {
          this.messageText = '';
          this.fileUrls = [];
        });
    },
    launchFileUpload() {
      (this.$refs.fileUpload as any).$refs.input.click();
    },
    async onFileUpload() {
      this.uploadProgress = 0;
      try {
        const uuid = uuidv4();
        const ref = storage.ref(`practice/messages/files/${uuid}`);
        const task = ref.put((this.file as unknown) as Blob);
        task.on('state_changed', (snapshot: any) => {
          this.uploadProgress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        });
        await task.then().catch((error: Error) => {
          console.error(error);
        });
        this.fileUrls.push({
          name: this.file?.name as string,
          url: await ref?.getDownloadURL()
        });
      } catch (error) {
        console.error(error);
      }
    }
  },
  created() {
    this.getData();
  }
});
